import { z } from 'zod';

import { getSingleValueWithOptionField } from './utils';

const MIN_AGE = 1;
const MAX_AGE = 99;

const AgeSchema = z
  .string()
  .trim()
  .nonempty({ message: 'questionnaire.age.inputRequiredError' })
  .transform((val, ctx) => {
    const parsed = parseInt(val);
    if (isNaN(parsed)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Not a number',
      });
    }
    return parsed;
  })
  .pipe(
    z
      .number()
      .gte(MIN_AGE, { message: 'questionnaire.age.minMaxError' })
      .lte(MAX_AGE, { message: 'questionnaire.age.minMaxError' }),
  );

const HighestEducationLevelSchema = getSingleValueWithOptionField(
  'questionnaire.highestEducationLevel.otherInputRequiredError',
  'questionnaire.highestEducationLevel.requiredError',
);
const CurrentOrganizationSchema = getSingleValueWithOptionField(
  'questionnaire.currentOrganization.otherInputRequiredError',
  'questionnaire.currentOrganization.requiredError',
);
const ExamAttendingObjectivesSchema = getSingleValueWithOptionField(
  'questionnaire.examAttendingObjectives.otherInputRequiredError',
  'questionnaire.examAttendingObjectives.requiredError',
);

const examinationSatisfactionField = z
  .string({ required_error: 'questionnaire.examinationSatisfaction.requiredError' })
  .trim()
  .nonempty({ message: 'questionnaire.examinationSatisfaction.requiredError' });

const ExaminationSatisfactionSchema = z.object({
  location: examinationSatisfactionField,
  staffServices: examinationSatisfactionField,
  systemUsability: examinationSatisfactionField,
  systemStability: examinationSatisfactionField,
});

export const QuestionnaireBaseSchema = z.object({
  age: AgeSchema,
  highestEducationLevel: HighestEducationLevelSchema,
  currentOrganization: CurrentOrganizationSchema,
  examAttendingObjectives: ExamAttendingObjectivesSchema,
  examinationSatisfaction: ExaminationSatisfactionSchema,
  comment: z.string().trim(),
});

export type QuestionnaireBaseInput = z.input<typeof QuestionnaireBaseSchema>;
export type QuestionnaireBaseOutput = z.output<typeof QuestionnaireBaseSchema>;
